const checkCountryLocale = (locale: string) => typeof window !== 'undefined' && window.location.pathname.includes(locale);

export default checkCountryLocale;
